function lengthValidator({ configs, input, msgs }) {
  const { maxlength, minlength } = configs;
  const { length } = input;

  if (minlength && length < parseFloat(minlength)) {
    if (msgs.min) {
      return `${msgs.min.replace(
        '%s',
        minlength,
      )} Min length: ${minlength}, Input Length: ${length}`;
    }
    return `Value is too short.  Min length: ${minlength}, Input Length: ${length}`;
  }

  if (maxlength && length > parseFloat(maxlength)) {
    if (msgs.max) {
      return `${msgs.max.replace(
        '%s',
        maxlength,
      )} Max length: ${maxlength}, Input Length: ${length}`;
    }
    return `Value is too long.  Max length: ${maxlength}, Input Length: ${length}`;
  }

  return null;
}

export default lengthValidator;
